import { lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import { RouteLoading } from "./components/utils/RouteLoading";
import { useAuth } from "./context/auth-context";
import "./scss/boss.scss";
import "./dayjsSetup";

const AuthenticatedApp = lazy(() => import("./AuthenticatedApp"));
const UnauthenticatedApp = lazy(() => import("./UnauthenticatedApp"));

const App = (props) => {
  const { user } = useAuth();
  const location = useLocation();

  // A share link is opened the same way whether or not the visitor has a BOSS account.
  // The signed-in app has no route for it, so it answered with a 404.
  const isPublicSharePage = location.pathname.startsWith("/shared-files");

  return (
    <ErrorBoundary resetKey={location.pathname + location.search}>
      <Suspense fallback={<RouteLoading />}>
        {user && !isPublicSharePage ? (
          <AuthenticatedApp {...props} />
        ) : (
          <UnauthenticatedApp {...props} />
        )}
      </Suspense>
    </ErrorBoundary>
  );
};

export default App;
